import { Component, OnInit } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UserService } from '@shared/services/user.service';
import { SnackService } from '@shared/services/snack.service';
import { GuardService } from '@shared/services/guard.service';
import { IUpdateUser, IUser } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { UserRole } from '@shared/enums/UserRole';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-users-edit',
    templateUrl: './admin-users-edit.component.html',
    styleUrls: ['./admin-users-edit.component.scss'],
    standalone: false
})
export class AdminUsersEditComponent extends AdminActionsDirective implements OnInit {
    roleTypes: UserRole[] = [UserRole.standard, UserRole.admin];
    formGroup: UntypedFormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private userService: UserService,
        private snack: SnackService,
        private guardService: GuardService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    get isMaster(): boolean {
        return this.guardService.currentUser && this.guardService.currentUser.mainUser.id === 'Z003X1DP';
    }

    get value(): IUpdateUser {
        return this.formGroup.getRawValue();
    }

    async updateUser(event: any): Promise<void> {
        this.disableSubmitter(event);

        if (this.formGroup.valid) {
            try {
                const result = await this.userService.updateUser(await this.buildItem());
                this.snack.openSnackBarSuccess(`User ${result.userData.fullName} updated successfully.`);

                if (
                    this.guardService.currentUser.mainUser.id === result.id ||
                    this.guardService.currentUser.id === result.id
                ) {
                    await this.userService.getMyUser();
                }
                this.goToUser(result);
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }

        this.enableSubmitter(event);
    }

    get item(): IUser {
        return this.selectedItem;
    }

    private buildItem(): Promise<IUpdateUser> {
        return Promise.resolve({
            id: this.item.id,
            userRole: this.value.userRole,
            userData: {
                id: this.item.id,
                fullName: this.item.userData.fullName,
                department: this.item.userData.department,
                departmentText: this.item.userData.departmentText,
                eMail: this.item.userData.eMail,
                firstName: this.item.userData.firstName,
                lastName: this.item.userData.lastName
            },
            settings: this.item.settings
        } as IUpdateUser);
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            fullName: { value: this.item.userData?.fullName, disabled: true },
            id: { value: this.item.id, disabled: true },
            department: { value: this.item.userData?.department, disabled: true },
            departmentText: { value: this.item.userData?.departmentText, disabled: true },
            eMail: { value: this.item.userData?.eMail, disabled: true },
            userRole: this.item.userRole
        });
    }
}
